import { render, staticRenderFns } from "./addQuestionBankWJ.vue?vue&type=template&id=0d5e01ed&scoped=true&"
import script from "./addQuestionBankWJ.vue?vue&type=script&lang=js&"
export * from "./addQuestionBankWJ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5e01ed",
  null
  
)

export default component.exports